import React from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import Griddle, {plugins, RowDefinition, ColumnDefinition} from 'griddle-react'
import {Context} from '../../context'
import {bind} from '../../helpers/utils'
import {subdomainLink} from '../../helpers/url'
import Icon from '../icon'
import ContextLoader from '../context-loader'
import SearchPattern from '../search-pattern'
import components from './columns'
import Filter from './filters'
import {Pagination, PageDropdown} from '../pagination'
import {viewerGuard} from 'helpers/url'


import './assessment.styl'

const {columns, headers} = components

const Layout = ({Table, Pagination, Filter}) => (
  <div className="assessments-search-table">
    <div className="head">
      <Filter />
      <Pagination />
    </div>
    <Table />
  </div>
)

function NoResults (props) {
  return (
    <div className={props.className}>
      <Text id="assessments_search_no_results_label" />
    </div>
  )
}

export default class Assessments extends React.Component {
  static contextType = Context

  constructor(props) {
    super(props)
    bind(this, 'goPage', 'goNext', 'goPrevious')
  }

  goPage (page) {
    this.context.navigate({}, this.context.match.params, {preserveQuery: true, query:{page}})
  }

  goNext () {
    const page = this.context.query.page ? Number.parseInt(this.context.query.page) : 1
    this.goPage(page + 1)
  }

  goPrevious () {
    const page = this.context.query.page ? Number.parseInt(this.context.query.page) : 1
    this.goPage(page - 1)
  }

  render () {
    const context = this.context 
    const {query, assessmentView, assessmentCount, languageId} = context
    const pageProperties = {
      currentPage: query.page ? Number.parseInt(query.page) : 1,
      pageSize: query.pageSize || 8,
      recordCount: assessmentCount
    }
    return (
      <ContextLoader id="assessmentView" className="assessments">
        <div className="wrapper">
          <div className="header">
            <a className="create-assessment" {...viewerGuard({target: "_blank", href: subdomainLink('assessment',languageId,'create')})}>
              <div className="icon-wrapper">
              </div>
              <div className="label-wrapper">
                <Text id="create_assessment_label" />
              </div>
            </a>
            <div style={{flexGrow: 1}} />
            <SearchPattern initialPattern={context.query.pattern} />
          </div>
          <div className="assessments-search-results">
            <Griddle
              data={assessmentView}
              components={{
                NoResults,
                PageDropdown,
                Pagination,
                Layout,
                Filter
              }}
              pageProperties={pageProperties}
              events={{
                onNext: this.goNext,
                onPrevious: this.goPrevious,
                onGetPage: this.goPage
              }}
            >
             <RowDefinition>
               <ColumnDefinition
                 id='name'
                 customHeadingComponent={headers.AssessmentHeader}
                 customComponent={columns.TitleColumn}
               />
               <ColumnDefinition
                 id='course'
                 customHeadingComponent={headers.AssessmentHeader}
                 customComponent={columns.CourseColumn}
               />
               <ColumnDefinition
                 id='template_type'
                 customHeadingComponent={headers.AssessmentHeader}
                 customComponent={columns.TypeColumn}
               />
               <ColumnDefinition
                 id='randomize'
                 customHeadingComponent={headers.AssessmentHeader}
                 customComponent={columns.RandomizeColumn}
               />
               <ColumnDefinition
                 id='links'
                 customHeadingComponent={headers.EmptyHeader}
                 customComponent={columns.AssessmentLinksColumn}
               />
             </RowDefinition>
            </Griddle>
          </div>
      </div>
    </ContextLoader>)
  }
}
